import { Button, Modal } from 'antd';
import styled from 'styled-components';
import { useAppDispatch } from '../../methods/redux/hooks';
import { startLoan } from '../../methods/redux/reducers/loan';

const ActionSection = styled.div`
	display: inline-flex;
	margin-left: 10px;
	cursor: pointer;

	& .deleteIcon {
		font-size: 20px;
		color: red;
		cursor: pointer;
	}
`;
interface IStartLoan {
	id: string;
}
const StartLoan = ({ id }: IStartLoan) => {
	const dispatch = useAppDispatch();

	const handle = async () => {
		dispatch(
			startLoan({
				loanId: id,
				status: 'processing',
			})
		);
	};

	const confirm = () => {
		Modal.confirm({
			title: 'Are you sure you want to Start Processing this Loan',
			onOk() {
				handle();
			},
		});
	};
	return (
		<ActionSection>
			<Button type="primary" onClick={confirm}>
				Process Loan
			</Button>
		</ActionSection>
	);
};

export default StartLoan;
